export default __webpack_public_path__ + "static/0208-b5e66ac140bdfbcb180882a90ec66685.png";